function alignmentTileSlider() {
    $('.js__product_slider .tile_title .tile_link').css('min-height', ``);
    $('.js__product_slider .js__non_buy_button button').css('min-height', ``);
    $('.js__product_slider .wrap_price').css('min-height', ``);
    $('.js__product_slider .js__temp').css('min-height', ``);
    $('.js__product_slider .tile_article').css('min-height', ``);


    $('.js__product_slider').each(function () {
        let maxHeight = 0;
        let maxHeightPrice = 0;
        let nonOneBuyClick = 0;
        let maxTemp = 0;
        let tileArticle = 0;

        $(this).find('.tile_element').each(function () {
            const nameTile = $(this).find('.tile_title .tile_link');
            const priceTile = $(this).find('.tile_button .wrap_price');
            const oneBuyClick = $(this).find('.tile_button .buy_one_click_good');
            const temp = $(this).find('.js__temp');
            const article = $(this).find('.tile_article');

            if (maxHeight <= nameTile.outerHeight()) {
                maxHeight = nameTile.outerHeight();
            }

            if (maxHeightPrice <= priceTile.outerHeight(true)) {
                maxHeightPrice = priceTile.outerHeight(true);
            }

            if (nonOneBuyClick <= oneBuyClick.outerHeight(true)) {
                nonOneBuyClick = oneBuyClick.outerHeight(true);
            }

            if (tileArticle <= article.outerHeight()) {
                tileArticle = article.outerHeight();
            }

            if (temp.length != 0 && maxTemp <= temp.outerHeight()) {
                maxTemp = temp.outerHeight();
            }
        });

        $(this).find('.tile_title .tile_link').css('min-height', `${maxHeight}px`);
        $(this).find('.js__non_buy_button button').css('margin-bottom', `${nonOneBuyClick}px`);
        $(this).find('.wrap_price').css('min-height', `${maxHeightPrice}px`);
        $(this).find('.js__temp').css('min-height', `${maxTemp}px`);
        $(this).find('.tile_article').css('min-height', `${tileArticle}px`);
    });
}

function alignmentTileSliderNewGood() {
    $('.js__product_slider_new_good .tile_title .tile_link').css('min-height', ``);
    $('.js__product_slider_new_good .js__non_buy_button button').css('min-height', ``);
    $('.js__product_slider_new_good .wrap_price').css('min-height', ``);
    $('.js__product_slider_new_good .js__temp').css('min-height', ``);
    $('.js__product_slider_new_good .tile_article').css('min-height', ``);

    $('.js__product_slider_new_good').each(function () {
        let maxHeight = 0;
        let maxHeightPrice = 0;
        let nonOneBuyClick = 0;
        let maxTemp = 0;
        let tileArticle = 0;

        $(this).find('.tile_element').each(function () {
            const nameTile = $(this).find('.tile_title .tile_link');
            const priceTile = $(this).find('.tile_button .wrap_price');
            const oneBuyClick = $(this).find('.tile_button .buy_one_click_good');
            const temp = $(this).find('.js__temp');
            const article = $(this).find('.tile_article');

            if (maxHeight <= nameTile.outerHeight()) {
                maxHeight = nameTile.outerHeight();
            }

            if (maxHeightPrice <= priceTile.outerHeight(true)) {
                maxHeightPrice = priceTile.outerHeight(true);
            }

            if (nonOneBuyClick <= oneBuyClick.outerHeight(true)) {
                nonOneBuyClick = oneBuyClick.outerHeight(true);
            }

            if (tileArticle <= article.outerHeight()) {
                tileArticle = article.outerHeight();
            }

            if (temp.length != 0 && maxTemp <= temp.outerHeight()) {
                maxTemp = temp.outerHeight();
            }
        });

        $(this).find('.tile_title .tile_link').css('min-height', `${maxHeight}px`);
        $(this).find('.js__non_buy_button button').css('margin-bottom', `${nonOneBuyClick}px`);
        $(this).find('.wrap_price').css('min-height', `${maxHeightPrice}px`);
        $(this).find('.js__temp').css('min-height', `${maxTemp}px`);
        $(this).find('.tile_article').css('min-height', `${tileArticle}px`);
    });
}

function alignmentTileGlobal(typeRows = 'rows', telegram = false) {
    $('.js__good_tile_global .tile_title .tile_link').css('min-height', ``);
    $('.js__good_tile_global .wrap_price').css('min-height', ``);
    $('.js__good_tile_global .js__non_buy_button button').css('min-height', ``);
    $('.js__good_tile_global .tile_availability .js__temp').css('min-height', ``);
    $('.js__good_tile_global .tile_article').css('min-height', ``);

    if ($(window).width() <= 768) {
        typeRows = 'rows';
    }

    if (typeRows == 'rows') {
        let row_length = 1;
        if (window.innerWidth >= 450 && window.innerWidth <= 1200) {
            row_length = 2
        } else if (window.innerWidth > 1200) {
            row_length = 3
        }

        $('.js__good_tile_global').each(function () {
            let rows_title = {};
            let rows_prise = {};
            let rows_button = {};
            let rows_temp = {};
            let rows_tile_article = {}
            let counter = 0;


            $(this).find('.tile_element').each(function (i) {
                const nameTile = $(this).find('.tile_title .tile_link');
                const priceTile = $(this).find('.tile_button .wrap_price');
                const oneBuyClick = $(this).find('.tile_button .buy_one_click_good');
                const temp = $(this).find('.tile_availability .js__temp');
                const tileArticle = $(this).find('.tile_article');

                if (rows_title[counter]) {
                    rows_title[counter] = [...rows_title[counter], nameTile.height()];
                } else {
                    rows_title[counter] = [nameTile.height()];
                }

                if (rows_temp[counter]) {
                    rows_temp[counter] = [...rows_temp[counter], temp.length == 0 ? 0 : temp.height()];
                } else {
                    rows_temp[counter] = [temp.length == 0 ? 0 : temp.height()];
                }

                if (rows_prise[counter]) {
                    rows_prise[counter] = [...rows_prise[counter], priceTile.outerHeight()];
                } else {
                    rows_prise[counter] = [priceTile.outerHeight()];
                }

                if (rows_tile_article[counter]) {
                    rows_tile_article[counter] = [...rows_tile_article[counter], tileArticle.outerHeight()];
                } else {
                    rows_tile_article[counter] = [tileArticle.outerHeight()];
                }

                if (rows_button[counter]) {
                    rows_button[counter] = [...rows_button[counter], (typeof oneBuyClick.outerHeight(
                        true)) == 'number' ? oneBuyClick.outerHeight(true) : 0];
                } else {
                    rows_button[counter] = [(typeof oneBuyClick.outerHeight(true)) == 'number' ?
                        oneBuyClick.outerHeight(true) : 0
                    ];
                }

                if ((i + 1) % row_length === 0) {
                    counter++;
                }
            })

            $(this).find('.tile_element').each(function (i) {
                const row_number = Math.floor(i / row_length);
                const row_title = rows_title[row_number].sort((a, b) => { return a - b }).reverse();
                const row_prise = rows_prise[row_number].sort((a, b) => { return a - b }).reverse();
                const row_button = rows_button[row_number].sort((a, b) => { return a - b }).reverse();
                const row_temp = rows_temp[row_number].sort((a, b) => { return a - b }).reverse();
                const row_tile_article = rows_tile_article[row_number].sort((a, b) => { return a - b }).reverse();


                $(this).find('.tile_title .tile_link').css('min-height', `${row_title[0]}px`);
                $(this).find('.js__non_buy_button button').css('margin-bottom', `${row_button[0]}px`);
                $(this).find('.wrap_price').css('min-height', `${row_prise[0]}px`);
                $(this).find('.tile_availability .js__temp').css('min-height', `${row_temp[0]}px`);
                $(this).find('.tile_article').css('min-height', `${row_tile_article[0]}px`);
            })
        });

        if (telegram) {
            return true;
        }
    }
}

function alignmentTilePorfolio() {
    $('.portfolio_page_tab .title_problem a').css('min-height', ``);

    let row_length = 1;
    if (window.innerWidth >= 576 && window.innerWidth <= 992) {
        row_length = 2
    } else if (window.innerWidth > 992) {
        row_length = 3
    }

    $('.portfolio_page_tab').each(function () {
        let rows_title = {};
        let counter = 0;

        $(this).find('.title_problem a').each(function (i) {
            if (rows_title[counter]) {
                rows_title[counter] = [...rows_title[counter], $(this).outerHeight()];
            } else {
                rows_title[counter] = [$(this).outerHeight()];
            }

            if ((i + 1) % row_length === 0) {
                counter++;
            }
        })

        $(this).find('.title_problem a').each(function (i) {
            const row_number = Math.floor(i / row_length);
            const row_title = rows_title[row_number].sort().reverse();

            $(this).css('min-height', `${row_title[0]}px`);
        })
    });
}

function alignmentTileArticle() {
    $('.js__alignment_tile_article .article_list_title').css('min-height', ``);

    let row_length = 1;
    if (window.innerWidth >= 576 && window.innerWidth <= 992) {
        row_length = 2
    } else if (window.innerWidth > 992) {
        row_length = 3
    }

    $('.js__alignment_tile_article').each(function () {
        let rows_title = {};
        let counter = 0;

        $(this).find('.article_list_title').each(function (i) {
            if (rows_title[counter]) {
                rows_title[counter] = [...rows_title[counter], $(this).outerHeight()];
            } else {
                rows_title[counter] = [$(this).outerHeight()];
            }

            if ((i + 1) % row_length === 0) {
                counter++;
            }
        })

        $(this).find('.article_list_title').each(function (i) {
            const row_number = Math.floor(i / row_length);
            const row_title = rows_title[row_number].sort().reverse();

            $(this).css('min-height', `${row_title[0]}px`);
        })
    });
}

function alignmentTilePorfolioSlider() {
    $('.js_block_tab_problem .title_problem a').css('min-height', ``);

    $('.js_block_tab_problem').each(function () {
        let height = 0;

        $(this).find('.title_problem a').each(function (i) {
            if ($(this).outerHeight() > height) {
                height = $(this).outerHeight();
            }
        })

        $(this).find('.title_problem a').each(function () {
            $(this).css('min-height', `${height}px`);
        })
    });
}

function reviewsAlignment() {
    $('.js_customer_reviews_list').each(function () {
        let maxHeight = 0;
        $(this).find('.customer_reviews_item').each(function () {
            const height = $(this).outerHeight()

            if (maxHeight < height) {
                maxHeight = height;
            }
        })

        $(this).find('.customer_reviews_item').css('min-height', `${maxHeight}px`);
    })
}


$(document).ready(function () {
    if ($(window).width() >= 769) {
        var rowType = localStorage.getItem('rowType');

        if (rowType === null) {
            alignmentTileGlobal('rows');
        } else if (rowType == 'row') {
            alignmentTileGlobal('row');
        } else {
            alignmentTileGlobal('rows');
        }
    } else {
        alignmentTileGlobal();
    }

    alignmentTileSlider();
    reviewsAlignment();
    alignmentTileArticle();

    window.alignmentTileGlobal = alignmentTileGlobal;
    window.alignmentTilePorfolio = alignmentTilePorfolio;
    window.alignmentTilePorfolioSlider = alignmentTilePorfolioSlider;
    window.alignmentTileSliderNewGood = alignmentTileSliderNewGood;
});

$(window).resize(function () {
    if ($(window).width() >= 769) {
        var rowType = localStorage.getItem('rowType');

        if (rowType === null) {
            alignmentTileGlobal('rows');
        } else if (rowType == 'row') {
            alignmentTileGlobal('row');
        } else {
            alignmentTileGlobal('rows');
        }
    } else {
        alignmentTileGlobal();
    }


    alignmentTileSliderNewGood();
    alignmentTileSlider();
    alignmentTilePorfolio();
    alignmentTilePorfolioSlider();
    reviewsAlignment();
    alignmentTileArticle();
});